import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const modal = (state: RootState) => state.common.modal;

const getModalStatus = createSelector(modal, ({ openModal }) => openModal);
const getModalRecordKey = createSelector(modal, ({ recordKey }) => recordKey);
const getModalType = createSelector(modal, ({ type }) => type);
const getModalParams = createSelector(modal, ({ params }) => params);

export { getModalStatus, getModalRecordKey, getModalType, getModalParams };
